import { render, staticRenderFns } from "./DetailsCallCentreTextBox.vue?vue&type=template&id=0d7931ac&scoped=true"
import script from "./DetailsCallCentreTextBox.vue?vue&type=script&lang=ts"
export * from "./DetailsCallCentreTextBox.vue?vue&type=script&lang=ts"
import style0 from "./DetailsCallCentreTextBox.vue?vue&type=style&index=0&id=0d7931ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7931ac",
  null
  
)

export default component.exports